import { handleWishListCount } from "./utils/global";
const images_galerie = document.querySelectorAll(".product__galerie>div"), pictures = document.querySelectorAll(".product__image>picture"), add_to_list = document.getElementById("addToList");
const initImageSwitcher = () => {
    images_galerie.forEach((e) => {
        e.addEventListener("click", () => {
            const id = e.id;
            const imgToShow = document.getElementById(`img_${id}`);
            const imgToHide = document.querySelectorAll(`picture:not(#img_${id})`);
            const buttonNotCurrent = document.querySelector(".product__galerie div.current");
            e.classList.add("current");
            buttonNotCurrent === null || buttonNotCurrent === void 0 ? void 0 : buttonNotCurrent.classList.remove("current");
            imgToShow === null || imgToShow === void 0 ? void 0 : imgToShow.classList.add("current");
            imgToHide === null || imgToHide === void 0 ? void 0 : imgToHide.forEach((e) => {
                e.classList.remove("current");
            });
        });
    });
};
const initWishList = () => {
    add_to_list === null || add_to_list === void 0 ? void 0 : add_to_list.addEventListener("click", () => {
        //@ts-ignore
        let currentProduct = product ? product : null;
        const wishlist = JSON.parse(localStorage.getItem('WishList') || '[]');
        if (!!currentProduct) {
            if (!wishlist.find((e) => e.id === currentProduct.id)) {
                wishlist.push(currentProduct);
                localStorage.setItem("WishList", JSON.stringify(wishlist));
                alert("Le produit a été ajouté à votre liste d'envie !");
            }
            else {
                alert("Ce produit est déja dans votre liste d'envies.");
            }
        }
        handleWishListCount();
    });
};
const init = () => {
    initImageSwitcher();
    initWishList();
};
document.addEventListener('DOMContentLoaded', () => {
    init();
});
